// extracted by mini-css-extract-plugin
export var deleteModal = "_kf-0";